import React, { useEffect, useState, useRef } from "react"
import { closeIcrHistoryIcon, revertHistoryIcon, showDiffEyeIcon, hideDiffEyeIcon } from '../AppIcons';
import axiosInstance from "../services/axiosInstance"
import APIUrls from "../services/APIUrls"
import { diff_match_patch } from 'diff-match-patch';
import InContextUtil from "../services/InContextUtil";
import jQuery from "jquery";
import moment from 'moment';
import SuccessNotification from './SuccessNotification';

const DeleteConfirmationModal = ({ 
  showDeleteConfirmation, 
  commentToDelete, 
  onCancel, 
  onConfirm 
}) => {
  if (!showDeleteConfirmation) return null;

  return (
    <div id="delete-feedback-modal" className='lightbox-panel' aria-labelledby="deleteFeedbackLabel" aria-modal="true" role="dialog">
      <div className="inner-lightbox-panel pb-0" style={{
        maxHeight: '600px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Fixed Header */}
        <div className="modal-header flex padd-lr">
          <h5 id="deleteFeedbackLabel">Delete Feedback</h5>
        </div>

        {/* Scrollable Content Area */}
        <div style={{
          flex: '1',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div className="lightbox-content padd-22" style={{
            flex: '1',
            overflowY: 'auto'
          }}>
            <p className="confirmation-text" style={{
              fontFamily: 'Poppins',
              fontWeight: 500,
              fontStyle: 'normal',
              fontSize: '14px',
              lineHeight: '23px',
              letterSpacing: '0px',
              marginBottom: '16px'
            }}>
              Do you want to delete this feedback?
            </p>

            {/* Scrollable Comment */}
            <div style={{
              maxHeight: '200px',
              overflowY: 'auto',
              marginBottom: '16px'
            }}>
              <p className="feedback-content" style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontStyle: 'italic',
                fontSize: '14px',
                lineHeight: '23px',
                letterSpacing: '0px',
                color: '#333',
                margin: '0',
                padding: '0',
                backgroundColor: 'transparent',
                border: 'none'
              }}>
                "{commentToDelete}"
              </p>
            </div>

            {/* Fixed Note Section */}
            <div className="note-section">
              <p className="note-label" style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '12px',
                lineHeight: '140%',
                letterSpacing: '0px',
                marginBottom: '4px',
                color: '#6c757d'
              }}>
                Note:
              </p>
              <p className="note-text" style={{
                fontFamily: 'Poppins',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '12px',
                lineHeight: '140%',
                letterSpacing: '0px',
                color: '#6c757d'
              }}>
                This process cannot be reversed if you proceed ahead.
              </p>
            </div>
          </div>
        </div>

        {/* Fixed Footer */}
        <div className="modal-footer modal-footer-border flex px-22">
          <button
            className="btn btn-bold first-focus cancelApprove"
            onClick={onCancel}
            style={{ marginRight: '12px' }}
          >
            Cancel
          </button>
          <button
            className="btn btn-bold active lastClick submitApprove"
            onClick={onConfirm}
            style={{ backgroundColor: '#1D4ED8', borderColor: '#1D4ED8' }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default function ShowHistoryHandler({
  projectId,
  parentHttpDomain,
  targetPreviewId = "target-preview",
  currentUserEmail,
  isAssignee = false,
  onFeedbackCountUpdate,
  feedbackCount
}) {


  const [popUpValue, setPopUpValue] = useState(false);
  const [translationUnitForHistory, setTranslationUnitForHistory] = useState();
  const currentTranslationUnitId = useRef();
  const [isEditHistoryTabActive, setIsEditHistoryTabActive] = useState(true);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [translationIndexToDelete, setTranslationIndexToDelete] = useState(null);
  const [commentIndexToDelete, setCommentIndexToDelete] = useState(null);
  // Add success notification state
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const seenCommentsRef = useRef(new Set());

  // FIX 1: Add useEffect for non-interactive background
  useEffect(() => {
    if (showDeleteConfirmation) {
      document.body.classList.add('delete-modal-open');
    } else {
      document.body.classList.remove('delete-modal-open');
    }
    
    return () => {
      document.body.classList.remove('delete-modal-open');
    };
  }, [showDeleteConfirmation]);

  const formatSeverity = (severity) => {
    if (!severity) return '';
    return severity.toLowerCase()
      .replace(/\b\w/g, l => l.toUpperCase())
      + ' error';
  };

  const formatCategoryType = (categoryType) => {
    if (!categoryType) return '';
    return categoryType.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  };

  const formatCategory = (category) => {
    if (!category) return '';
    return category.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())
      .replace(/3rd Party/g, '3rd Party');
  };


// Replace the old formatSeverity function with this:
const formatSeverityWithoutError = (severity) => {
  if (!severity) return '';
  return severity.toLowerCase()
    .replace(/\b\w/g, l => l.toUpperCase());
    // Removed the "+ ' error'" part
};

  // Add the handler functions
  const handleDeleteClick = (translationIndex, commentIndex, commentText) => {
    setTranslationIndexToDelete(translationIndex);
    setCommentIndexToDelete(commentIndex);
    setCommentToDelete(commentText);
    setShowDeleteConfirmation(true);
    setPopUpValue(false); 
  };

  const handleConfirmDelete = () => {
    if (translationIndexToDelete !== null && commentIndexToDelete !== null) {
      handleDeleteComment(translationIndexToDelete, commentIndexToDelete);
    }
    setShowDeleteConfirmation(false);
    setCommentToDelete(null);
    setTranslationIndexToDelete(null);
    setCommentIndexToDelete(null);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
    setCommentToDelete(null);
    setTranslationIndexToDelete(null);
    setCommentIndexToDelete(null);
  };



  const [showDifferences, setShowDifferences] = useState([]);
  useEffect(() => {
    if (translationUnitForHistory?.translations) {
      setShowDifferences(new Array(translationUnitForHistory.translations.length).fill(false));
    }
  }, [translationUnitForHistory]);

  
  const reversedTranslations = Array.isArray(translationUnitForHistory?.translations) ? [...translationUnitForHistory.translations].reverse() : [];

  if (translationUnitForHistory) {
  seenCommentsRef.current = new Set();
}

  const isDifferenceShown = translationUnitForHistory?.translations?.reverse().map((translation, index) => {
    return index !== translationUnitForHistory?.translations.length - 1 && showDifferences[index];
  });

  const highlightDifferences = (updated, original) => {
    if (!original || !updated) {
      return null;
    }
    const dmp = new diff_match_patch();
    const diffs = dmp.diff_main(original, updated);
    dmp.diff_cleanupSemantic(diffs);

    return diffs.map((part, i) => {
      const color = part[0] === 0 ? 'normal' : part[0] === -1 ? 'deletion' : 'insertion';
      const textDecoration = part[0] === -1 ? 'line-through' : 'none';
      return (
        <span key={i} style={{ backgroundColor: color === 'normal' ? 'transparent' : color === 'deletion' ? '#FF9999' : '#99FF99', textDecoration }}>
          {part[1]}
        </span>
      );
    });
  };


  const description = translationUnitForHistory?.translations?.reverse().map((translation, index) => {
    const length = translationUnitForHistory?.translations.length
    return isDifferenceShown[index]
      ? highlightDifferences(translationUnitForHistory?.translations[length - index - 1]?.text, translationUnitForHistory.translations[length - index - 2]?.text)
      : translationUnitForHistory?.translations[length - index - 1]?.text;
  });

  const handleToggleHighlight = (index) => {
    setShowDifferences((prevShowDifferences) => {
      const newShowDifferences = [...prevShowDifferences];
      newShowDifferences[index] = !newShowDifferences[index];
      return newShowDifferences;
    });
  };


  function revertTranslation(translationId, index) {
    axiosInstance.post(APIUrls.TRANSLATION_UNIT_REVERT_TRANSLATION(translationId, index - 1)).then(res => {
      axiosInstance.get(APIUrls.CUSTOMER_TRANSLATION_UNIT(translationId))
        .then(res => {
          const updatedTranslationUnit = transformBlankToNull(res.data);
          updatePreviewWithSegment(updatedTranslationUnit, true);
          setTranslationUnitForHistory(updatedTranslationUnit);

          // Update the latest translation in the history in Line by Line
          let latestTranslation = updatedTranslationUnit.translations[updatedTranslationUnit.translations.length - 1].rawText;
          jQuery("#" + currentTranslationUnitId.current + " > .tu-html").html(latestTranslation)

        }).catch(err => {
          console.error(err)
        })
    })
  }


  const transformBlankToNull = (obj) => {
    return JSON.parse(JSON.stringify(obj, (key, value) => {
      return (value === "" ? null : value);
    }));
  };


  function updatePreviewWithSegment(segment, lblEdit) {

    if(!segment) return;
    segment.latestTranslation = segment.translations[segment.translations.length - 1];
    segment.latestTranslation.tokenizedText = InContextUtil.tokenizeSegmentContent(segment.latestTranslation.rawText, 'STANDARD');
    let syncedTuSnippets = null;
    const syncedTranslations = lblEdit ? segment.translations.filter(t => t.isMostRecent === false) : segment.translations.filter(t => t.synced === true);
    if (syncedTranslations.length > 0) {
      const latestSyncedTranslation = syncedTranslations[syncedTranslations.length - 1];
      syncedTuSnippets = InContextUtil.tokenizeSegmentContent(latestSyncedTranslation.rawText, 'STANDARD');
    }

    messageSegmentUpdateToInContext(segment.docSegPos, segment.latestTranslation, syncedTuSnippets, false);

  }

  function messageSegmentUpdateToInContext(docSegPos, translation, syncedTuSnippets, isToken) {

    document.getElementById('target-preview')?.contentWindow
      .postMessage(
        JSON.stringify({
          action: "replace",
          docSegPos: docSegPos,
          syncedTuSnippets: syncedTuSnippets,
          isToken: isToken,
          newRawText: translation.rawText,
          newTokenizedText: translation.tokenizedText
        }), '*');
  }

  const handleDeleteComment = (translationIndex, commentIndex) => {
  try {
    if (!translationUnitForHistory || !translationUnitForHistory.translations) {
      console.error('No translation data available');
      return;
    }

    const hadCommentsBefore = translationUnitForHistory.translations.some(
      (t) => Array.isArray(t.comments) && t.comments.length > 0
    );

    const originalTranslationIndex = translationUnitForHistory.translations.length - 1 - translationIndex;
    const targetTranslation = translationUnitForHistory.translations[originalTranslationIndex];
    
    if (!targetTranslation || !Array.isArray(targetTranslation.comments)) {
      console.error('No comments in target translation');
      return;
    }

    const actualLocalCommentIndex = targetTranslation.comments.length - 1 - commentIndex;
    const targetComment = targetTranslation.comments[actualLocalCommentIndex];
    if (!targetComment) {
      console.error('Target comment not found');
      return;
    }

    const targetKey = targetComment.id || `${targetComment.text}-${targetComment.createdDate}-${targetComment.userId || ""}`;

    const matchingGlobalIndices = [];
    let currentGlobalIndex = 0;
    translationUnitForHistory.translations.forEach((translation) => {
      if (Array.isArray(translation.comments)) {
        translation.comments.forEach((comment) => {
          const commentKey = comment.id || `${comment.text}-${comment.createdDate}-${comment.userId || ""}`;
          if (commentKey === targetKey) {
            matchingGlobalIndices.push(currentGlobalIndex);
          }
          currentGlobalIndex++;
        });
      }
    });

    if (matchingGlobalIndices.length === 0) {
      console.error('No matching comments found');
      return;
    }

    matchingGlobalIndices.sort((a, b) => b - a);

    let deleteChain = Promise.resolve();
    matchingGlobalIndices.forEach((globalIdx) => {
      deleteChain = deleteChain.then(() => {
        return axiosInstance.post(APIUrls.TRANSLATION_UNIT_DELETE_COMMENT(translationUnitForHistory.id, globalIdx));
      });
    });

    deleteChain.then(() => {
      return axiosInstance.get(APIUrls.CUSTOMER_TRANSLATION_UNIT(translationUnitForHistory.id));
    }).then((res) => {
      const updatedTU = transformBlankToNull(res.data);
      setTranslationUnitForHistory(updatedTU);
      
      const hasCommentsAfter = updatedTU.translations.some(
        (t) => Array.isArray(t.comments) && t.comments.length > 0
      );
      
      // Only update feedback count if all comments are gone
      if (hadCommentsBefore && !hasCommentsAfter) {
          if (onFeedbackCountUpdate && typeof onFeedbackCountUpdate === 'function') {
            onFeedbackCountUpdate(feedbackCount - 1);
          }
          window.parent.postMessage(JSON.stringify({
            action: "UPDATE_FEEDBACK_HIGHLIGHT",
            docSegPos: updatedTU.docSegPos,
            hasFeedback: false,
            feedbackCount: feedbackCount - 1
          }), '*');
        }
        jQuery("body").addClass("modal-open");
        window.parent.postMessage(JSON.stringify({
          action: "REFRESH_HIGHLIGHTED_TUS",
          filterType: "COMMENTED"
        }), '*');
        window.parent.postMessage(JSON.stringify({
          action: "REFRESH_LBL_FEEDBACK_LIST"
        }), '*');
        // Show success notification
        setNotificationMessage('Feedback Deleted');
        setShowSuccessNotification(true);
      })
      .catch(err => console.error('Error deleting comment:', err));
  } catch (err) {
    console.error('Error in handleDeleteComment:', err);
  }
};

  const showEditHistoryTab = () => { 
    setIsEditHistoryTabActive(true);
    jQuery(".edit-history").removeClass("hide");
    jQuery(".edit-history-btn").addClass("active");
    jQuery(".feedback-btn").removeClass("active");
    jQuery(".feedback-content").addClass("hide");
  };

  const showFeedbackTab = () => { 
    setIsEditHistoryTabActive(false);
    jQuery(".feedback-content").removeClass("hide");
    jQuery(".edit-history").addClass("hide");
    jQuery(".edit-history-btn").removeClass("active");
    jQuery(".feedback-btn").addClass("active");
  };

  useEffect(() => {
    function handleHistoryActions(e) {
      if (!e.data) return

      let message
      try {
        message =
          e.type === "webpackInvalid" ||
            (typeof e.data === "object" && e.data.type === "webpackWarnings") ||
            (typeof e.data === "object" && e.data.type === "webpackClose")
            ? e.data
            : JSON.parse(e.data)
      } catch (err) {
        // Silent out webpack related exceptions
        return
      }

      // Handle show history
      if (message.action === "showHistory") {
        currentTranslationUnitId.current = message.translationUnitId;
        setPopUpValue(true);
        setIsEditHistoryTabActive(true);
        axiosInstance.get(APIUrls.SHOW_TRANSLATION_HISTORY(projectId, message.docSegPos))
          .then(res => {
            // setIsLineByLineTabStatus(false);
            setTranslationUnitForHistory(transformBlankToNull(res.data));
            jQuery("body").addClass("modal-open");
            showEditHistoryTab();
          }).catch(err => {
            console.error(err)
          })

      }
    }

    // Add event listener for message events
    window.addEventListener("message", handleHistoryActions)

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("message", handleHistoryActions)
    }
  }, [])



  return (
    <>
      {/* FIX 1: Overlay for non-interactive background */}
      {showDeleteConfirmation && (
        <div className="modal-backdrop"></div>
      )}
      {popUpValue && (
        <div
          className="right-modal icr-right-modal"
          aria-label="history"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-header flex">
            <div className="left flex-center">
              <div className="group-btn flex-center" role="tablist">
                <button
                  role="tab"
                  aria-label="edit history"
                  className={`dashboard-btn edit-history-btn ${isEditHistoryTabActive ? 'active' : ''}`}
                  onClick={showEditHistoryTab}
                  style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    marginRight: '-1px' 
                  }}
                >
                  Edit History
                </button>
                <button
                  role="tab"
                  aria-label="feedback"
                  className={`dashboard-btn feedback-btn ${!isEditHistoryTabActive ? 'active' : ''}`}
                  onClick={showFeedbackTab}
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                >
                  Feedback
                </button>
              </div>
            </div>
            <button
              className="close flex-center rightClose"
              aria-label="close"
              onClick={(e) => {
                jQuery("body").removeClass("modal-open");
                jQuery(".showingHistory").trigger("focus");
                jQuery(".showingHistory").removeClass("showingHistory");
              }}
            >
              {closeIcrHistoryIcon}
            </button>
          </div>

          <div className="modal-content">
            <ul className="edit-history">
              {reversedTranslations.map((translation, index) => {
                const translationIndex =
                  translationUnitForHistory?.translations.length - index;
                return (
                  <li key={index}>
                    <div
                      className="edit-history-text">
                      <div className="text flex-center space-between">
                        <div
                          className="text-left flex items-center"
                          style={{ gap: 12 }}
                        >
                          {index !==
                            translationUnitForHistory?.translations.length - 1 && (
                              <>
                                <button
                                  onClick={() => handleToggleHighlight(index)}
                                  title="Show or hide changes"
                                  className="button-icon wd-ht24">
                                  <span className="wd-ht24 flex-center">
                                    {showDifferences[index]
                                      ? showDiffEyeIcon
                                      : hideDiffEyeIcon}
                                  </span>
                                </button>

                                {!translation?.isMostRecent && (
                                  <div className="divider-vertical" />
                                )}

                                {!translation?.isMostRecent && (
                                  <button
                                    aria-label="Revert to this Revision"
                                    title="Revert to this Revision"
                                    onClick={() =>
                                      revertTranslation(
                                        translationUnitForHistory?.id,
                                        translationUnitForHistory?.translations
                                          ?.length - index
                                      )
                                    }
                                    className="button-icon wd-ht24">
                                    {revertHistoryIcon}
                                  </button>
                                )}
                              </>
                            )}

                          {index ===
                            translationUnitForHistory?.translations.length - 1 &&
                            !translation?.isMostRecent && (
                              <button
                                aria-label="Revert to this Revision"
                                title="Revert to this Revision"
                                onClick={() =>
                                  revertTranslation(
                                    translationUnitForHistory?.id,
                                    translationUnitForHistory?.translations
                                      ?.length - index
                                  )
                                }
                                className="button-icon wd-ht24">
                                {revertHistoryIcon}
                              </button>
                            )}
                        </div>

                        <span
                          className="editor-date flex-center gap-6">
                          {moment
                            .utc(translation.createdDate)
                            .format("YYYY-MM-DD • HH:mm:ss UTC")}
                        </span>
                      </div>

                      <div className="text-left text-order-wrap">
                        <p className="para-order-number">{translationIndex}</p>
                        <p className="order-description">{description[index]}</p>
                      </div>


                      {translationIndex !== 1 && (!isAssignee || translation.editedBy === currentUserEmail) && (
                        <div className="feedback-details-container" style={{ marginTop: '8px' }}>
                          <div className="feedback-by-container">
                            <span className="feedback-by-label">Edited by: </span>
                            <span className="feedback-by-value">{translation.editedBy || "Unknown"}</span>
                          </div>

                          {/* Edit metadata - moved below Edited by info */}
                          {(translation.severity || translation.categoryType || translation.category) && (
                            <div className="feedback-meta" style={{ marginTop: '4px' }}>
                              {translation.severity && !translation.categoryType && !translation.category ? (
                                // Only severity exists
                                <span className="severity">{formatSeverityWithoutError(translation.severity)}</span>
                              ) : translation.categoryType && translation.category ? (
                                // Both categoryType and category exist
                                <span>
                                  {translation.severity && (
                                    <span className="severity">{formatSeverityWithoutError(translation.severity)} &gt; </span>
                                  )}
                                  <span className="category-type">{formatCategoryType(translation.categoryType)}</span>
                                  <span className="category">: {formatCategory(translation.category)}</span>
                                </span>
                              ) : translation.categoryType ? (
                                // Only categoryType exists
                                <span>
                                  {translation.severity && (
                                    <span className="severity">{formatSeverityWithoutError(translation.severity)} &gt; </span>
                                  )}
                                  <span className="category-type">{formatCategoryType(translation.categoryType)}</span>
                                </span>
                              ) : translation.category ? (
                                // Only category exists
                                <span>
                                  {translation.severity && (
                                    <span className="severity">{formatSeverityWithoutError(translation.severity)} &gt; </span>
                                  )}
                                  <span className="category">{formatCategory(translation.category)}</span>
                                </span>
                              ) : (
                                // Fallback: only severity
                                translation.severity && (
                                  <span className="severity">{formatSeverityWithoutError(translation.severity)}</span>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {translationIndex === 1 && (
                        <div className="message flex-center">
                          <p className="original-translation">
                            Original Translation
                          </p>
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
            <ul className={`feedback-content ${isEditHistoryTabActive ? 'hide' : ''}`}>
              {reversedTranslations.map((translation, index) => (
                <li key={index}>
                  {translation.comments?.slice().reverse().map((comment, commentIndex) => {
                    // ADD DEDUPLICATION LOGIC HERE
                    const commentKey = comment.id || `${comment.text}-${comment.createdDate}-${comment.userId}`;
                    
                    // Skip if already seen
                    if (seenCommentsRef.current.has(commentKey)) {
                      return null;
                    }
                    
                    seenCommentsRef.current.add(commentKey);
                    return (
                      <div key={commentKey} className="feedback-card edit-history-text">
                        <div className="text flex-center space-between">
                          <div className="text-left flex items-center" style={{ gap: 12 }}>
                            {/* Placeholder for alignment with edit history */}
                            <span className="wd-ht24"></span>
                          </div>
                          <span className="editor-date flex-center gap-6">
                            {moment.utc(comment.createdDate).format("YYYY-MM-DD • HH:mm:ss UTC")}
                          </span>
                        </div>


                        <div className="text-left text-order-wrap">
                          {/* Removed the para-order-number (count) */}
                          <div className="feedback-content-wrapper">
                            {/* Feedback text */}
                            <p className="feedback-comment">{comment.text}</p>

                            {/* Translation text */}
                            <div className="translation-text-container">
                              <p className="translation-text">{translation.text}</p>
                            </div>

                            <div className="feedback-details-container">
                              {/* Feedback by */}
                              {(!isAssignee || comment.userId === currentUserEmail) && (
                                <div className="feedback-by-container">
                                  <span className="feedback-by-label">Feedback by: </span>
                                  <span className="feedback-by-value">{comment.userId || "Unknown"}</span>
                                </div>
                              )}

                              {/* Feedback metadata */}
                              {comment.feedback && (
                                <div className="feedback-meta">
                                  {comment.feedback.severity && !comment.feedback.categoryType && !comment.feedback.category ? (
                                    // Only severity exists
                                    <span className="severity">{formatSeverity(comment.feedback.severity)}</span>
                                  ) : comment.feedback.categoryType && comment.feedback.category ? (
                                    // Both categoryType and category exist
                                    <span>
                                      {comment.feedback.severity && (
                                        <span className="severity">{formatSeverity(comment.feedback.severity)} &gt; </span>
                                      )}
                                      <span className="category-type">{formatCategoryType(comment.feedback.categoryType)}</span>
                                      <span className="category">: {formatCategory(comment.feedback.category)}</span>
                                    </span>
                                  ) : comment.feedback.categoryType ? (
                                    // Only categoryType exists
                                    <span>
                                      {comment.feedback.severity && (
                                        <span className="severity">{formatSeverity(comment.feedback.severity)} &gt; </span>
                                      )}
                                      <span className="category-type">{formatCategoryType(comment.feedback.categoryType)}</span>
                                    </span>
                                  ) : comment.feedback.category ? (
                                    // Only category exists
                                    <span>
                                      {comment.feedback.severity && (
                                        <span className="severity">{formatSeverity(comment.feedback.severity)} &gt; </span>
                                      )}
                                      <span className="category">{formatCategory(comment.feedback.category)}</span>
                                    </span>
                                  ) : (
                                    // Fallback: only severity
                                    comment.feedback.severity && (
                                      <span className="severity">{formatSeverity(comment.feedback.severity)}</span>
                                    )
                                  )}
                                </div>
                              )}

                              {/* Delete button at the bottom */}
                              {comment.userId === currentUserEmail && (
                                <div className="delete-button-container">
                                  <button
                                    aria-label="Delete feedback"
                                    title="Delete Feedback"
                                    onClick={() => handleDeleteClick(index, commentIndex, comment.text)}
                                    className="delete-btn-primary-outlined"
                                  >
                                    Delete
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </li>
              ))}
              {reversedTranslations.every(t => !t.comments || t.comments.length === 0) && (
                <li className="no-feedback-enhanced">
                  <div className="no-feedback-content">
                    <h3 className="no-feedback-title">No Feedback Provided</h3>
                    <p className="no-feedback-description">
                      Till now, no feedback has been provided by any user. To provide one,
                      select <span className="provide-feedback-highlight">'Provide Feedback' </span>
                      after tapping on a TU segment.
                    </p>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
      <DeleteConfirmationModal
      showDeleteConfirmation={showDeleteConfirmation}
      commentToDelete={commentToDelete}
      onCancel={handleCancelDelete}
      onConfirm={handleConfirmDelete}
    />
     {showSuccessNotification && (
      <SuccessNotification
        message={notificationMessage}
        onClose={() => setShowSuccessNotification(false)}
      />
    )}

    </>

  );
}

